/* oxlint-disable no-top/no-top-level-side-effects -- Declarative Drizzle schema, like the actor _tables definitions. */
import { sql } from "@-/com.npmjs.drizzle-orm";
import { crudTable, date, index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * One journey on the China map, paid for in Han. The table is an append-only ledger: the
 * learner's location, in-transit state and visited places are all derived from it, and the Han
 * balance subtracts every live row's `costHan`. A teleport (to an already-visited place) is a
 * zero-cost row whose `arrivesAt` equals its `departedAt`. Every journey the learner does not turn
 * back from earns HanMiles by its `distanceKm`; `hanMilesRedeemed` spends them on a flight fare.
 */
export const travelTripTable = crudTable(
  "travel_trip",
  {
    arrivesAt: date("arrives_at").notNull(),
    /** Set when the learner turns back: they return to the origin and the fare is forfeited. */
    cancelledAt: date("cancelled_at"),
    costHan: integer("cost_han").notNull(),
    departedAt: date("departed_at").notNull(),
    /** China map (MCA) adcode of the destination place. */
    destinationAdcode: integer("destination_adcode").notNull(),
    distanceKm: integer("distance_km").notNull(),
    /** The real fare in fen (¥0.01), so half-yuan rail fares stay exact. */
    fareFen: integer("fare_fen").notNull(),
    /**
     * HanMiles spent on this fare. `costHan` is what was left to pay after their discount, while
     * `fareFen` stays the real fare.
     */
    hanMilesRedeemed: integer("han_miles_redeemed").notNull().default(0),
    /** `TransportMode`, or `"teleport"`. */
    mode: text("mode").notNull(),
    originAdcode: integer("origin_adcode").notNull(),
    /** Null for a teleport. */
    seatClass: text("seat_class"),
  },
  (table) => [
    index("travel_trip_departed_at_idx")
      .on(table.departedAt)
      .where(sql`${table.deletedAt} is null`),
  ],
);

export type TravelTrip = typeof travelTripTable.$inferSelect;
/* oxlint-enable no-top/no-top-level-side-effects */
